import { useDispatch } from 'react-redux';

export const useDispatcher = () => {
  const dispatch = useDispatch();

  const doAction = <T extends {}>(type: string, payload: T) =>
    dispatch({ type, payload });

  const doEmptyAction = (type: string) => doAction<any>(type, undefined);

  return { dispatch, doEmptyAction, doAction };
};

export default useDispatcher;
